module.exports = __webpack_public_path__ + "static/media/iconValores4.86cbcaf7.svg";